import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
export function useSelectOptions(t0) {
  const $ = _c(17);
  const {
    value,
    items,
    getDisplayTextOfItem,
    getKeyOfItem
  } = t0;
  let t1;
  if ($[0] !== getDisplayTextOfItem || $[1] !== getKeyOfItem) {
    t1 = (item, index) => ({
      item,
      key: getKeyOfItem(item, index),
      displayText: getDisplayTextOfItem(item)
    });
    $[0] = getDisplayTextOfItem;
    $[1] = getKeyOfItem;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const createOptionForItem = t1;
  let t2;
  if ($[3] !== createOptionForItem || $[4] !== items) {
    t2 = items.map(createOptionForItem);
    $[3] = createOptionForItem;
    $[4] = items;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const options = t2;
  let t3;
  if ($[6] !== options || $[7] !== value) {
    let t4;
    if ($[9] !== value) {
      t4 = o => o.item === value;
      $[9] = value;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = options.find(t4);
    $[6] = options;
    $[7] = value;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let option = t3;
  if (!option) {
    let t4;
    if ($[11] !== createOptionForItem || $[12] !== value) {
      t4 = createOptionForItem(value, -1);
      $[11] = createOptionForItem;
      $[12] = value;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    option = t4;
  }
  const currentOption = option;
  let t4;
  if ($[14] !== currentOption || $[15] !== options) {
    t4 = {
      options,
      currentOption
    };
    $[14] = currentOption;
    $[15] = options;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}
export function getKeyOfSelectOption(option: SelectOption<unknown>): string {
  return option.key;
}
export function getDisplayTextOfSelectOption(option: SelectOption<unknown>): string {
  return option.displayText;
}
export type UseSelectOptionsOptions<T> = {
  value: T;
  items: Array<T>;
  getKeyOfItem: (item: T, index: number) => string;
  getDisplayTextOfItem: (item: T) => string;
};
export type UseSelectOptionsReturnValue<T> = {
  options: Array<SelectOption<T>>;
  currentOption: SelectOption<T>;
};
export type SelectOption<T> = {
  key: string;
  displayText: string;
  item: T;
};